module.exports = __webpack_public_path__ + "static/media/VidgoTablet.6ff264a6.png";